import React from 'react';
import { useMultiFactorMutation } from '../../../hooks/Auth';
import { useForm } from 'react-hook-form';
import MultiFactorVerificationCodeForm, {
  MultiFactorVerificationFormValues,
} from '../../auth-views/components/MultiFactorVerificationCodeForm';
import CenterLayout from '../../vendorlink-views/components/CenterLayout';
import ModalLayout from '../components/ModalLayout';
import { Button, Space } from 'antd';
import ErrorMessage from '../../auth-views/components/ErrorMessage';
import { Link } from 'react-router-dom';

interface VerificationCodeStepProps {
  phoneNumber: string;
  verificationId: string;
  onComplete: () => void;
  onCancel: () => void;
}

const VerificationCodeStep: React.FC<VerificationCodeStepProps> = ({
  phoneNumber,
  verificationId,
  onComplete,
  onCancel,
}) => {
  const { useResolveMultiFactor } = useMultiFactorMutation();
  const { control, handleSubmit } = useForm<MultiFactorVerificationFormValues>({});
  const onVerificationCodeSubmit = async (values: MultiFactorVerificationFormValues) => {
    if (verificationId) {
      await useResolveMultiFactor.mutateAsync({ ...values, verificationId });
      onComplete();
    }
  };
  return (
    <CenterLayout>
      <ModalLayout
        header={
          <Space direction="vertical">
            <div className="heading-xs">Enter your verification code</div>
            <div className="text-content-secondary">
              Input the 6-digit code we sent to <b>{phoneNumber}</b>.
            </div>
          </Space>
        }
        content={
          <>
            <ErrorMessage />
            <MultiFactorVerificationCodeForm control={control} onSubmit={handleSubmit(onVerificationCodeSubmit)} />
          </>
        }
        footer={
          <>
            <Space>
              <Button
                disabled={useResolveMultiFactor.isLoading}
                onClick={handleSubmit(onVerificationCodeSubmit)}
                type="primary"
              >
                Continue
              </Button>
              <Button onClick={onCancel} type="text">
                Back
              </Button>
            </Space>
            <Link to="#" onClick={() => Intercom('show')}>
              <b>I need help</b>
            </Link>
          </>
        }
      />
    </CenterLayout>
  );
};

export default VerificationCodeStep;
